// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentTitle__root___I98s-"};